import React, { useState } from 'react';
import {
  Box,
  Avatar,
  TextField,
  Typography,
  IconButton,
  Button,
  Grid,
  InputAdornment,
} from '@mui/material';
import { Email, PhotoCamera } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { investorApi } from '../../api/api';
import { Snackbar, Alert } from '@mui/material';
import { loginUser } from '../../reducers/userReducer';

const ProfilePage = () => {
  const user = useSelector((state) => state.user);
  const userId = user.userId;
  const dispatch = useDispatch();
  const [name, setName] = useState(user.firstName);
  const [email,setEmail] = useState(user.Email);
  const [mobile,setMobile] = useState(user.Mobilenumber);
  const [profilePicture, setProfilePicture] = useState(user.avatar);
  const [selectedFile, setSelectedFile] = useState(null);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  }
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePicture(URL.createObjectURL(file)); // For preview
      setSelectedFile(file); // For uploading
    }
  };

  const handleSaveChanges = async () => {
    const formData = new FormData();
    formData.append("FirstName", name);
    formData.append("Email", email);
    formData.append("Mobilenumber", mobile);
    if (selectedFile) {
      formData.append("avatar", selectedFile);
    }


    try {
      const response = await investorApi.updateProfile(userId, formData);
      if (response.status == 200) {
        dispatch(
          loginUser({
            user: {
              id: userId,
              firstName: name,
              lastName: user.lastName,
              avatar: response.data?.data?.avatar,
              role: user.role,
              Mobilenumber: mobile,
              Email: email

            }
          })
        )
        showSnackbar('Profile Updated Successfully', 'success');
      }
      else {
        showSnackbar('something went wrong', 'error');
      }
    }

   catch (error) {

  if (error.response && error.response.status === 409) {
    // Show backend's message (e.g. "Mobile number already exists.")
    showSnackbar(error.response.data.message, 'error');
  } else {
    showSnackbar('Failed to update profile', 'error');
  }
}



  };

  const handleChangePassword = async () => {
    let hasError = false;
    setConfirmPasswordError('');
    setNewPasswordError('');

    if (newPassword != confirmPassword) {
      setConfirmPasswordError("Passwords does not match");
      hasError = true;

    }
    if (newPassword.length < 8) {
      setNewPasswordError('password must be atleast 8 characters');
      hasError = true;
    }
    if (hasError) return;

    try {
      const passres = await investorApi.updatePassword(userId, {
        // currentPassword: currentPassword,
        newPassword: newPassword
      })
      if (passres.status == 200) {
        showSnackbar("passwords changed successfully", 'success');
      }
      else {
        showSnackbar('something went wrong', 'error');
      }
    }
    catch (error) {
      showSnackbar("failed to update password", 'error');
    }


  };

  return (
    <Box sx={{ padding: 4, backgroundColor: '#fff', minHeight: '100vh' }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 3 }}>
        Edit Profile
      </Typography>

      <Grid container spacing={4}>
        {/* LEFT SIDE */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#fff',
              padding: 3,
              borderRadius: 3,
              boxShadow: 2,
              textAlign: 'center',
            }}
          >
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Avatar
                alt="Profile Picture"
                src={profilePicture}
                sx={{ width: 100, height: 100, margin: 'auto' }}
              />
              <IconButton
                component="label"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  boxShadow: 1,
                }}
              >
                <PhotoCamera />
                <input type="file" hidden accept="image/*" onChange={handleImageChange} />
              </IconButton>
            </Box>

            <Box mt={3}>
              <Typography align="left" sx={{ fontWeight: 'bold', mb: 1 }}>
                Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                sx={{ mb: 2 }}
              />

              <Typography align="left" sx={{ fontWeight: 'bold', mb: 1 }}>
                Email
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 2 }}
              />

              <Typography align="left" sx={{ fontWeight: 'bold', mb: 1 }}>
                Contact Number
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                sx={{ mb: 3 }}
              />


              <Button variant="contained" color="primary" onClick={handleSaveChanges}>
                Save Changes
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#fff',
              padding: 3,
              borderRadius: 3,
              boxShadow: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
              Change Password
            </Typography>

            {/* <TextField
              label="Current Password"
              type="password"
              fullWidth
              variant="outlined"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              sx={{ mb: 2 }}
            /> */}

            <TextField
              label="New Password"
              type="password"
              fullWidth
              variant="outlined"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              error={Boolean(newPasswordError)}
              helperText={newPasswordError}
              sx={{
                mb: 2,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: newPasswordError ? 'red' : 'black',
                  },
                  '&:hover fieldset': {
                    borderColor: newPasswordError ? 'red' : 'black',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: newPasswordError ? 'red' : 'black',
                  },
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                },
                '& .MuiInputLabel-root': {
                  color: 'black',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'black',
                },
              }}
            />

            <TextField
              label="Confirm Password"
              type="password"
              fullWidth
              variant="outlined"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              error={Boolean(confirmPasswordError)}
              helperText={confirmPasswordError}
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: confirmPasswordError ? 'red' : 'black',
                  },
                  '&:hover fieldset': {
                    borderColor: confirmPasswordError ? 'red' : 'black',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: confirmPasswordError ? 'red' : 'black',
                  },
                },
                '& .MuiFormHelperText-root': {
                  color: 'red',
                },
                '& .MuiInputLabel-root': {
                  color: 'black',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'black',
                },
              }}
            />


            <Button variant="contained" color="secondary" onClick={handleChangePassword}>
              Change Password
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProfilePage;
